import React from "react"
import PropTypes from "prop-types"
import { Input } from "@tencent/spaui"
import { withApi } from "@tencent/react-aio"
import * as ActionTypes from "@/stores/sale/actions"

/**
 * CustomerId 输入框
 */
class AccountIdInput extends React.Component {
  static propTypes = {
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    adPlatformType: PropTypes.string, //投放方式
    acceptAccountId: PropTypes.bool, // 是否接受 AccountId，默认 true
    acceptMpUserName: PropTypes.bool, // 是否接受 MpUserName，默认 false
    onChange: PropTypes.func.isRequired, // (e, value) => {}
    onBlur: PropTypes.func.isRequired,
    className: PropTypes.string,
    webApi: PropTypes.object.isRequired,
  }

  static defaultProps = {
    acceptAccountId: true,
    acceptMpUserName: false,
  }

  constructor(props) {
    super(props)
    if (props.value) {
      this.state = {
        value: props.value,
      }
    } else {
      this.state = {}
    }
  }

  render() {
    const { className, customerReadOnly } = this.props
    const { value } = this.state
    return <Input disabled={customerReadOnly} className={className} value={value} maxLength={45} onChange={this.handleChange} />
  }

  update(e, state) {
    this.setState(state, () => {
      this.props.onChange(e, this.state)
    })
  }

  handleChange = (e, value) => {
    const { acceptAccountId, acceptMpUserName } = this.props
    this.update(e, {
      value: value,
      status: value ? "pending" : undefined,
      customer: undefined,
      error: undefined,
    })
    if (this.timer) {
      clearTimeout(this.timer)
    }
    if (value) {
      if (value.length < 5) {
        this.update(e, {
          status: "error",
          error: "长度不足",
        })
      } else {
        const parseAccountId = parseInt(value)
        const accountId = parseAccountId && parseAccountId.toString() === value ? parseAccountId : undefined
        if (accountId) {
          if (acceptAccountId) {
            // 处理 AccountId 信息
            this.timer = setTimeout(() => {
              this.timer = undefined
              this.findSubAdvertiser(e, accountId)
            }, 500)
          } else {
            this.update(e, {
              status: "error",
              error: "格式不正确",
            })
          }
        } else if (acceptMpUserName && value.startsWith("gh_")) {
          if (value.length === 15) {
            // 处理 MpUserName
            this.timer = setTimeout(() => {
              this.timer = undefined
              this.findSubAdvertiser(e, undefined, value)
            }, 500)
          } else {
            this.update(e, {
              status: "error",
              error: "长度不足",
            })
          }
        } else if (value.startsWith("wx")) {
          // try app id
          this.timer = setTimeout(() => {
            this.timer = undefined
            this.findSubAdvertiser(e, undefined, undefined, value)
          }, 500)
        } else if (value.startsWith("unibd")) {
          // try unibd
          this.timer = setTimeout(() => {
            this.timer = undefined
            this.findSubAdvertiser(e, undefined, undefined, undefined, value)
          }, 500)
        } else {
          // first try mpUserName, if no data found then try app id
          this.timer = setTimeout(() => {
            this.timer = undefined
            this.findSubAdvertiser(e, undefined, value, undefined, this.findSubAdvertiser(e, undefined, undefined, value, this.setErrorWrongFormat))
          }, 500)
        }
      }
    }
  }

  findSubAdvertiser(e, accountId, mpUserName, appId, unibd, onError) {
    this.props.webApi
      .checkCustomer()
      .dispatchJson(ActionTypes.FETCH_CUSTOMER, {
        data: {
          accountId,
          mpUserName,
          appId,
          unibd,
        },
      })
      .then(
        (resp) => {
          if (this.searchTimer) {
            clearTimeout(this.searchTimer)
          }

          if (this.props.adPlatformType === "AD_PLATFORM_TYPE_MP" && accountId) {
            if (accountId === resp.customerId && resp.mp && (resp.mp.mpUserName || resp.mp.wechatAppId)) {
              if (unibd) resp.unibd = unibd
              this.update(e, {
                customer: resp,
                status: "success",
              })
              this.searchTimer = setTimeout(() => {
                this.props.searchDataFromCs(accountId)
              }, 300)
            } else {
              this.update(e, {
                status: "error",
                error: "请重新选择投放方式",
              })
            }
          } else if (this.props.adPlatformType === "AD_PLATFORM_TYPE_GDT" && accountId) {
            if (accountId === resp.customerId) {
              this.update(e, {
                customer: resp,
                status: "success",
              })
              this.searchTimer = setTimeout(() => {
                this.props.searchDataFromCs(accountId)
              }, 300)
            }
          } else if (mpUserName || appId || unibd) {
            if (mpUserName === (resp.mp ? resp.mp.mpUserName : undefined) || appId === (resp.mp ? resp.mp.wechatAppId : undefined) || unibd) {
              if (unibd) resp.unibd = unibd
              this.update(e, {
                customer: resp,
                status: "success",
              })

              this.searchTimer = setTimeout(() => {
                this.props.searchDataFromCs(accountId)
              }, 300)
            }
          }
        },
        (error) => {
          if (onError) {
            onError()
          } else {
            this.setErrorMessage(e, error)
          }
        }
      )
  }

  setErrorMessage = (e, error) => {
    if (!error) {
    }
    this.update(e, {
      status: "error",
      error: error ? error.message : "格式不正确",
    })
  }

  setErrorWrongFormat = (e) => {
    this.setErrorMessage(e)
  }
}

export default withApi(AccountIdInput)
